<template>
  <div class="IndexLiveHighlights contentBox">
    <router-link class="index-title" :to="{ path: '/liveHighlights', query:{ name: '现场花絮' } }" target="_blank">现场花絮</router-link>
    <div class="content-pc" v-if="ispc">
      <swiper class="live-swiper-pc" ref="liveSwiper" :options="options">
        <swiper-slide v-for="(item, index) in live" :key="index">
          <img :src="item.imagePath" />
        </swiper-slide>
      </swiper>
      <!-- <div class="index-swiper-prev swiper-btn" @click="prev"></div>
      <div class="index-swiper-next swiper-btn" @click="next"></div> -->
	  <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
	  <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
    </div>
    <div class="content" v-else>
      <ul>
        <li v-for="(item, index) in live" :key="index">
          <img :src="item.imagePath" />
        </li>
      </ul>
    </div>
    <router-link class="index-more" :to="{ path: '/liveHighlights', query:{ name: '现场花絮' } }">查看更多</router-link>
  </div>
</template>

<script>
  import { LiveHighlightsAllApi } from '../request/api.js'
  export default{
    name: 'IndexLiveHighlights',
    props:{
      ispc: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        live: [],
        options: {
          slidesPerView: 4,
          slidesPerColumn: 2,
          spaceBetween: 20,
          navigation: {
            nextEl: '.IndexLiveHighlights .swiper-button-next',
            prevEl: '.IndexLiveHighlights .swiper-button-prev'
          }
        }
      }
    },
    mounted() {
      LiveHighlightsAllApi({
        PageSize: this.ispc ? 16 : 12,
        PageNumber: 1,
        Sorting: 'displayindex desc,revisabilityDate desc'
      }).then(res => {
        this.live = res.items;
      });
    },
    // methods: {
    //   next() {
    //   	this.swiper.slideNext();
    //   },
    //   prev() {
    //   	this.swiper.slidePrev();
    //   }
    // },
    // computed: {
    //   swiper() {
    //     return this.$refs.liveSwiper.$swiper
    //   }
    // }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .content-pc{
      height: 350px;
      margin: 40px auto 0;
      position: relative;
      padding: 0 50px;
    }

    .live-swiper-pc{
      height: 350px;
    }

    /* 自定义swiper切换按钮 */
    .swiper-btn{
      width: 30px;
      height: 51px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
    }
    .index-swiper-next{
      /* background: url(../assets/image/index-swiper-right.png) no-repeat center center; */
      /* background-size: 10px 21px; */
      right: 0;
    }

    .index-swiper-next:after,.index-swiper-prev:after{
      font-family: swiper-icons;
      font-size: var(--swiper-navigation-size);
      text-transform: none !important;
      letter-spacing: 0;
      text-transform: none;
      font-variant: initial;
      line-height: 1;
      color: #FFFFFF;
    }

    .index-swiper-next:after{
      content: 'next';
    }

    .index-swiper-prev:after{
      content: 'prev';
    }

    .index-swiper-prev{
      /* background: url(../assets/image/index-swiper-left.png) no-repeat center center; */
      /* background-size: 10px 21px; */
      left: 0;
    }

    /* 更多 */
    .index-more{
      margin: 40px auto 95px;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .IndexLiveHighlights .content{
      margin: 0;
    }

    .IndexLiveHighlights ul{
      background: rgba(0,0,0,.3);
      padding: .3rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .IndexLiveHighlights li{
      width: 2.04rem;
      height: 1.44rem;
    }

    .IndexLiveHighlights li:nth-child(3n){
      margin-bottom: .09rem;
    }

    .IndexLiveHighlights li img{
      width: 100%;
      height: 100%;
    }

    .IndexLiveHighlights .index-more{
      margin: .3rem auto 1.3rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexLiveHighlights.vue